import { AfterContentInit, AfterViewInit, Component, ContentChild,
  ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { SelectionModel, SelectionChange } from '@angular/cdk/collections';
import { MatColumnDef, MatHeaderRowDef, MatPaginator, MatPaginatorIntl,
  MatRowDef, MatSort, MatTable, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'data-table',
  template: `<mat-card>

  <ng-content select="mat-toolbar.main"></ng-content>

  <ng-content select="mat-toolbar.alternative"></ng-content>

  <mat-table #table [dataSource]="dataSource">

    <!-- Checkbox column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected(nonDisabledOnPage())"
                      [indeterminate]="selection.hasValue() && !isAllSelected(nonDisabledOnPage())"
                      [disabled]="nonDisabledOnPage().length < 1">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="select(row); $event.stopPropagation()">
        <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [disabled]="disabled(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <!-- End checkbox column -->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

    <mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="rowclick.emit(row); select(row)"
        [class.selected]="selection.isSelected(row)">
    </mat-row>
  </mat-table>

  <mat-paginator #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons">
  </mat-paginator>

</mat-card>
`,
  styles: [`:host{
  display:block;
  position:relative; }
  :host ::ng-deep mat-toolbar{
    padding:0 24px; }
    :host ::ng-deep mat-toolbar h1{
      font-weight:400; }
    :host ::ng-deep mat-toolbar.main{
      background-color:#fff; }
    :host ::ng-deep mat-toolbar.alternative{
      display:grid;
      grid-template-columns:1fr 1fr;
      -webkit-box-align:center;
          -ms-flex-align:center;
              align-items:center; }
      :host ::ng-deep mat-toolbar.alternative p.mat-caption{
        font-size:16px;
        -ms-flex-item-align:center;
            align-self:center;
        margin:0; }
      :host ::ng-deep mat-toolbar.alternative section.actions{
        justify-self:end; }

mat-card{
  padding:0; }

.mat-column-select{
  overflow:initial;
  -webkit-box-flex:0;
      -ms-flex-positive:0;
          flex-grow:0;
  -ms-flex-negative:0;
      flex-shrink:0;
  -ms-flex-preferred-size:48px;
      flex-basis:48px; }

mat-row{
  -webkit-transition:background-color 200ms linear;
  transition:background-color 200ms linear;
  cursor:pointer; }
  mat-row:hover{
    background-color:#EEE; }
  mat-row.selected{
    background-color:#F5F5F5; }
  mat-row mat-cell:first-child{
    padding:14px 14px;
    padding-left:24px;
    margin-right:-14px;
    margin-left:-24px; }
`]
})
export class DataTableComponent<T> implements AfterContentInit, AfterViewInit, OnInit {

  @Input() displayedColumns: string[] = [];
  @Input() dataSource: MatTableDataSource<T>;
  @Input() selection: SelectionModel<T> = new SelectionModel<any>();

  @Input() pageSize = 10;
  @Input() pageSizeOptions: number [] = [];
  @Input() showFirstLastButtons = true;
  @Input() paginatorINTL: MatPaginatorIntl = null;

  @Output() rowclick = new EventEmitter<T>();

  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;
  @ContentChild(MatHeaderRowDef) headerRowDef: MatHeaderRowDef;
  @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<T>>;
  @ViewChild(MatTable) table: MatTable<T>;

  @ContentChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  connectedRows: T [] = [];

  @Input() disabled = (row: any): boolean => false;


  isAllSelected(filtered: T []): boolean {
    return (filtered.find((row) => ! this.selection.isSelected(row)) === undefined);
  }

  masterToggle(): void {
    const filtered = this.nonDisabledOnPage();

    this.isAllSelected(filtered) ?
      this.selection.deselect(...filtered) :
      this.selection.select(...filtered);
  }

  nonDisabledOnPage(): T [] {
    return this.connectedRows.filter((row) => ! this.disabled(row));
  }

  select(row): void {
    if ( ! this.disabled(row)) {
      this.selection.toggle(row);
    }
  }

  ngOnInit(): void {
    this.dataSource.connect().subscribe((rows) => this.connectedRows = rows);
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.sort.sortChange.subscribe(() => this.selection.clear());

    if (this.paginatorINTL) {
      this.paginator._intl = this.paginatorINTL;
    }
  }

  ngAfterContentInit(): void {
    this.columnDefs.forEach(columnDef => this.table.addColumnDef(columnDef));
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
}
